import type {
  CommonAPI,
  PostalAreasGET,
  FeaturesCallback,
  ValidationRulesCallback,
  PostalCodeAndPlaceName,
} from '@modules/store/common/types/CommonAPI.interface';
import type Features from '@modules/store/common/types/Features.entity';
import type FetchFeaturesConfig from '@modules/store/common/types/FetchFeaturesConfig.entity';
import type FetchValidationRulesConfig from '@modules/store/common/types/FetchValidationRulesConfig.entity';
import type ValidationRuleEntries from '@modules/store/common/types/ValidationRuleEntries.entity';
import type ValidationRules from '@modules/store/common/types/ValidationRules.entity';
import husleieapi from '@modules/husleie-api';
import { SignupApi, AddressApi } from '@modules/smartmieteapi';
import { merge } from 'lodash';

export default class API implements CommonAPI {
  fetchValidationRules(validationRulesConfig: FetchValidationRulesConfig, callback: ValidationRulesCallback): void {
    const apiValidationRules: ValidationRuleEntries = {}; // possible API fetch

    const appValidationRuleEntries: ValidationRuleEntries = validationRulesConfig.loader(validationRulesConfig);
    const validationRuleEntries: ValidationRuleEntries = merge(appValidationRuleEntries, apiValidationRules);

    const mergedValidationRules: ValidationRules = { rules: validationRuleEntries };

    callback(mergedValidationRules);
  }

  fetchFeatures(featuresConfig: FetchFeaturesConfig, callback: FeaturesCallback): void {
    const defaultFeatures: Features = {
      regionToggles: {},
    };

    const appFeatures: Features = featuresConfig.loader();
    const features: Features = merge(appFeatures, defaultFeatures);

    callback(features);
  }

  fetchPostalAreasByPostalCode(get: PostalAreasGET): Promise<PostalCodeAndPlaceName[]> {
    return new Promise(resolve => {
      const api = new AddressApi();
      api
        .getPostalArea(get.countryCode, get.postalCode)
        .then((l: any) => {
          const data: PostalCodeAndPlaceName[] = [];
          l.forEach((e: any) => {
            data.push({
              postalCode: e.postalCode,
              placeName: e.placeName,
            });
          });
          resolve(data);
        })
        .catch(() => {
          console.warn(`Country ${get.countryCode}, postal code ${get.postalCode} not found or request failed`);
          resolve([]);
        });
    });
  }

  fetchCheckEmailInUse(email: string): Promise<undefined | boolean> {
    return new Promise(resolve => {
      const api = new SignupApi();
      const body: any = {
        email: email,
      };
      api
        .checkEmailInUse({ body })
        .then((r: any) => {
          resolve(r.inUse);
        })
        .catch(() => {
          console.warn(`Check email failed`);
          resolve(undefined);
        });
    });
  }

  verifyCellPhoneSend(cellPhone: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const hlApi = new husleieapi();

      hlApi.call('SignupApi.verifyCellPhoneSend', { cellPhone }, (error: any, data: { token: string }) => {
        if (error) {
          reject(error);
        } else {
          resolve(data.token);
        }
      });
    });
  }

  verifyCellPhoneVerify(cellPhone: string, token: string, code: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const hlApi = new husleieapi();

      hlApi.call(
        'SignupApi.verifyCellPhoneVerify',
        { cellPhone, token, code },
        (error: any, data: { success: boolean }) => {
          if (error) {
            reject(error);
            return;
          }

          resolve(Boolean(data.success));
        }
      );
    });
  }
}
